export enum SearchType {
	Program,
	Course,
}

export interface ISearchCriteria {
	searchType: SearchType;
	term?: string;
	matchAll?: boolean;
	fullSearch?: boolean;
	filter?: string;
	scoringProfile?: string;
	pageSize?: number;
	page?: number;
	sort?: string;
}

export interface IFilter {
	key: string;
	value: string;
	label: string;
	expression: string;
	removable: boolean;
}

export interface IFacetValue {
	count: number;
	value: string;
	display: string;
}

export interface IExtendedFacetValue extends IFacetValue {
	relevant: boolean;
}

export interface IFacets {
	[index: string]: IFacetValue[];
}

export interface IProgram {
	searchScore: number;
	id: string;
	title: string;
	level: string;
	degree: string;
	description: string;

	area: string;
	group: string;
	subject: string;

	inState: number;
	outState: number;
	costs: string;

	deliveryMode: string;
	presence: string;

	deliverySpeed: string;
	length: string;
	averageTime: string;

	language: string;

	url: string;

	institutionName: string;
	city: string;
	state: string;
	stateCode: string;

	msiCodes: string[];

	[index: string]: string | number | string[];
}

export interface ICourse {
	searchScore: number;
	id: string;

	yearTerm: string;
	termDisplay: string;

	courseDepartment: string;
	courseNumber: string;

	title: string;
	degree: string;
	description: string;

	credits: number;
	unitForCredits: string;

	courseLevel: string;

	prerequisites: string;

	multipleSessions: boolean;
	scheduleOverview: string;

	area: string;
	group: string;
	subject: string;

	inState: number;
	outState: number;
	costs: string;

	deliveryMode: string;
	presence: string;

	deliverySpeed: string;

	language: string;
	additionalInformation: string;

	url: string;

	institutionName: string;
	city: string;
	state: string;
	stateCode: string;

	msiCodes: string[];

	[index: string]: string | number | boolean | string[];
}

export interface ISearchResult {
	searchType: SearchType;
	items: IProgram[] | ICourse[];
	facets: IFacets;
	count: number;
}

export interface ISearchService {
	search (criteria: ISearchCriteria): Promise<ISearchResult>;
	facet (criteria: ISearchCriteria, column: string): Promise<IFacetValue[]>;
}

export function isCourse (obj: ICourse | IProgram): obj is ICourse {
	return (obj as ICourse).courseDepartment !== undefined;
}
